const routes = [
  {
    path: 'texthollow',
    name: 'texthollow',
    component: () => import(/* webpackChunkName: "texthollow" */ '@/modules/texthollow/index.vue')
  },
];

export default routes;